import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="text-center sticky-footer">
        <p className="mb-0 text-light">
          © 2026 Nathan Perfetti. All rights reserved.
        </p>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
